import $axios from '@/axios-instance.js'

export const metaService = {
  getDatabaseTableMetrics,
  getUserRoleMetrics,
  getRoles,
  getPermissions,
  getProductStructure,
  getTaskStructure,
  getDocumentStructure,
  getCountries
}

function getProductStructure () {
  return $axios.get(`${process.env.ROOT_API}/meta/product-structure`).then(response => {
    return response.data
  })
}

function getTaskStructure () {
  return $axios.get(`${process.env.ROOT_API}/meta/task-structure`).then(response => {
    return response.data
  })
}

function getDocumentStructure () {
  return $axios.get(`${process.env.ROOT_API}/meta/document-structure`).then(response => {
    return response.data
  })
}

function getDatabaseTableMetrics () {
  return $axios.get(`${process.env.ROOT_API}/meta/database-table-metrics`).then(response => {
    return response.data
  })
}

function getUserRoleMetrics () {
  return $axios.get(`${process.env.ROOT_API}/meta/user-role-metrics`).then(response => {
    return response.data
  })
}

function getRoles () {
  return $axios.get(`${process.env.ROOT_API}/meta/roles`).then(response => {
    return response.data
  })
}

function getPermissions () {
  return $axios.get(`${process.env.ROOT_API}/meta/permissions`).then(response => {
    return response.data
  })
}

function getCountries () {
  return $axios.get(`${process.env.ROOT_API}/meta/countries`).then(response => {
    return response.data
  })
}



// WEBPACK FOOTER //
// ./src/services/meta.service.js